<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre2">Personen:</h1>
<p class="calibre1"><i class="calibre3">Deputierte des Nationalkonvents:</i><br class="calibre4"/>
  Georg Danton<br class="calibre4"/>
  Legendre<br class="calibre4"/>
  Camille Desmoulins<br class="calibre4"/>
  Hérault-Séchelles<br class="calibre4"/>
  Lacroix<br class="calibre4"/>
  Philippeau<br class="calibre4"/>
  Fabre d'Eglantine<br class="calibre4"/>
  Mercier<br class="calibre4"/>
  Thomas Payne</p>
<p class="calibre1"><i class="calibre3">Mitglieder des Wohlfahrtsausschusses:</i><br class="calibre4"/>
  Robespierre<br class="calibre4"/>
  St. Just<br class="calibre4"/>
  Barère<br class="calibre4"/>
  Collot d'Herbois<br class="calibre4"/>
  Billaud-Varennes</p>
<p class="calibre1">Chaumette, <i class="calibre3">Prokurator des Gemeinderats</i></p>
<p class="calibre1">Dillon, <i class="calibre3">ein General</i></p>
<p class="calibre1">Fouquier-Tinville, <i class="calibre3">öffentlicher Ankläger</i></p>
<p class="calibre1">Amar <i class="calibre3">und</i> Vouland, <i class="calibre3">Mitglieder des Sicherheitsausschusses</i></p>
<p class="calibre1">Herman <i class="calibre3">und</i> Dumas, <i class="calibre3">Präsidenten des Revolutionstribunales</i></p>
<p class="calibre1">Paris, <i class="calibre3">ein Freund Dantons</i></p>
<p class="calibre1">Simon <i class="calibre3">, Souffleur</i></p>
<p class="calibre1">Weib Simons</p>
<p class="calibre1">Laflotte</p>
<p class="calibre1">Julie, <i class="calibre3">Dantons Gattin</i></p>
<p class="calibre1">Lucile <i class="calibre3">, Gattin des Camille Desmoulins</i></p>
<p class="calibre1">Rosalie, Adelaide <i class="calibre3">und</i> Marion, <i class="calibre3">Grisetten</i></p>
<p class="calibre1"><i class="calibre3">Damen am Spieltisch, Herren und Damen sowie junger Herr und Eugenie auf einer Promenade, Bürger, Bürgersoldaten, Lyoner und andere Deputierte, Jakobiner, Präsidenten des Jakobinerklubs und des Nationalkonvents, Schließer, Henker und Fuhrleute, Männer und Weiber aus dem Volk, Grisetten, Bänkelsänger, Bettler usw.</i></p>
<p class="calibre1"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?4c12d07c